import { useCotiPluginContext } from '@/context/PrivacyBridgeContext';
import { useDashboardAccess } from '@/hooks/useDashboardAccess';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const ProtectedDashboardRoute = ({ children }: { children: React.ReactNode }) => {
    const { walletAddress, isConnected, handleConnect, chainId } = useCotiPluginContext();
    const networkChainId = chainId ? parseInt(chainId) : 7082400;
    const accessStatus = useDashboardAccess(walletAddress || null, networkChainId);

    if (!isConnected) {
        return (
            <div className="min-h-screen flex flex-col">
                <Navbar />
                <main className="flex-1 flex items-center justify-center">
                    <Card className="glass box-glow max-w-md w-full mx-4">
                        <CardHeader className="text-center space-y-4">
                            <CardTitle className="text-xl">Connect Wallet</CardTitle>
                            <CardDescription>
                                Connect your wallet to access the Bridge Dashboard.
                            </CardDescription>
                            <Button
                                onClick={handleConnect}
                                className="rounded-full btn-gradient-wallet"
                            >
                                Connect Wallet
                            </Button>
                        </CardHeader>
                    </Card>
                </main>
                <Footer />
            </div>
        );
    }

    if (accessStatus === 'loading') {
        return (
            <div className="min-h-screen flex flex-col">
                <Navbar />
                <main className="flex-1 flex items-center justify-center">
                    <div className="text-center space-y-3">
                        <RefreshCw className="h-8 w-8 animate-spin mx-auto text-primary" />
                        <p className="text-muted-foreground">Checking access permissions...</p>
                    </div>
                </main>
                <Footer />
            </div>
        );
    }

    if (accessStatus === 'denied') {
        return (
            <div className="min-h-screen flex flex-col">
                <Navbar />
                <main className="flex-1 flex items-center justify-center">
                    <Card className="glass box-glow max-w-md w-full mx-4">
                        <CardHeader className="text-center space-y-4">
                            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
                                <AlertCircle className="h-8 w-8 text-destructive" />
                            </div>
                            <CardTitle className="text-xl">Access Denied</CardTitle>
                            <CardDescription>
                                Your wallet is not registered as an admin or operator.
                                Contact the contract owner to request access.
                            </CardDescription>
                        </CardHeader>
                    </Card>
                </main>
                <Footer />
            </div>
        );
    }

    return <>{children}</>;
};

export default ProtectedDashboardRoute;
